const getScrollParent = (element: HTMLElement | null): HTMLElement | Window => {
  if (!element) return window

  const style = getComputedStyle(element)
  const excludeStaticParent = style.position === 'absolute'
  const overflowRegex = /(auto|scroll)/

  let parent = element.parentElement
  while (parent) {
    const parentStyle = getComputedStyle(parent)
    if (excludeStaticParent && parentStyle.position === 'static') {
      parent = parent.parentElement
      continue
    }
    if (overflowRegex.test(parentStyle.overflow + parentStyle.overflowY + parentStyle.overflowX)) {
      return parent
    }
    parent = parent.parentElement
  }

  return window
}

const isElementVisible = (element: HTMLElement, parent: HTMLElement | Window): boolean => {
  const rect = element.getBoundingClientRect()

  if (parent === window) {
    return rect.top >= 0 && rect.bottom <= window.innerHeight
  }

  const parentRect = (parent as HTMLElement).getBoundingClientRect()
  return rect.top >= parentRect.top && rect.bottom <= parentRect.bottom
}

const getRelativeOffsetTop = (element: HTMLElement, parent: HTMLElement): number => {
  let offset = 0
  let el: HTMLElement | null = element

  while (el && el !== parent) {
    offset += el.offsetTop
    el = el.offsetParent as HTMLElement
  }

  return offset
}

/**
 * @function smoothScroll - плавная прокрутка к элементу с настраиваемой скоростью
 */

export const smoothScroll = (element: HTMLElement | null, duration = 300) => {
  if (!element) return

  const scrollParent = getScrollParent(element)

  // Текущая позиция скролла
  const startPosition = scrollParent === window ? window.pageYOffset : (scrollParent as HTMLElement).scrollTop

  // Целевая позиция элемента внутри контейнера
  const elementPosition =
    scrollParent === window
      ? element.getBoundingClientRect().top + window.pageYOffset
      : getRelativeOffsetTop(element, scrollParent as HTMLElement)

  // Если уже виден — не скроллим
  if (isElementVisible(element, scrollParent)) return

  let startTime: number | null = null

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    const easeOutQuart = 1 - Math.pow(1 - progress, 4)

    const newPosition = startPosition + (elementPosition - startPosition) * easeOutQuart

    if (scrollParent === window) {
      window.scrollTo(0, newPosition)
    } else {
      // eslint-disable-next-line prettier/prettier
      (scrollParent as HTMLElement).scrollTop = newPosition
    }

    if (timeElapsed < duration) requestAnimationFrame(animation)
  }

  requestAnimationFrame(animation)
}
